var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector71(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V12.5C0.5 13.6046 1.39543 14.5 2.5 14.5H5.5C6.60457 14.5 7.5 13.6046 7.5 12.5V5.125C7.5 4.02043 6.60457 3.125 5.5 3.125H5.22222C4.11765 3.125 3.22222 4.02043 3.22222 5.125V11.4375",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V12.5C0.5 13.6046 1.39543 14.5 2.5 14.5H5.5C6.60457 14.5 7.5 13.6046 7.5 12.5V5.125C7.5 4.02043 6.60457 3.125 5.5 3.125H5.22222C4.11765 3.125 3.22222 4.02043 3.22222 5.125V11.4375",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector71);
export default __webpack_public_path__ + "static/media/Vector 71.299a7a410eb07431ac1745134ac1b299.svg";
export { ForwardRef as ReactComponent };